import * as React from 'react';
import {none, option, Option} from "ts-option";
import {PlaceholderProps} from "../../../../components/common/props/PlaceholderProps";
import {Icon} from "../Icon/Icon";
import InputWithIcon from "./InputWithIcon";
import CurrencyHelper from "../../../../helper/CurrencyHelper";

interface ComponentProps {
	/**
	 * Currency input change callback.
	 */
	onChange: (value: Option<string>) => void;
	/**
	 * Currency input value.
	 */
	value?: Option<string>;
	/**
	 * Max length of input value integer part.
	 */
	maxIntPlaces?: number;
	/**
	 * Indicates if field is disabled.
	 */
	disabled?: boolean;
}

type Props = ComponentProps & PlaceholderProps;

export default class CurrencyInputWithIcon extends React.Component<Props, {}> {
	public static defaultProps: Partial<Props> = {
		value: none,
		maxIntPlaces: 22 // backend limit
	};

	render() {
		return (
			<InputWithIcon prependIcon={Icon.Finance}
						   disabled={this.props.disabled}
						   type={"text"}
						   value={this.props.value.getOrElse("")}
						   onChange={this.onChange}
						   placeholder={this.props.placeholder}
						   iconVariant={"gray"}/>
		);
	}

	onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (!event.target.value) {
			this.props.onChange(none);
		}
		else {
			if (CurrencyHelper.isInCurrencyFormat(event.target.value) && this.testMaxIntegerPlaces(event.target.value)) {
				this.props.onChange(option(event.target.value));
			}
		}
	};

	testMaxIntegerPlaces = (value: string) => {
		if (this.props.maxIntPlaces) {
			return value.split(".")[0].length <= this.props.maxIntPlaces;
		}
		return true;
	}
}
